export const internacionalizacao = () => {
    const selectCultures = document.querySelectorAll(".cultura");
    const culturaSelecionada = document.getElementsByClassName(
        "cultura-selecionada"
    );
    for (const botaoCultura of culturaSelecionada) {
        botaoCultura.innerHTML = document.querySelector(
            `a.cultura[data-culture="${CULTURE_EMPREGARE}"]`
        ).innerHTML;
    }
    selectCultures.forEach(
        (selectCulture) =>
        (selectCulture.onclick = (e) =>
            document
                .querySelectorAll(".cultura-selecionada")
                .forEach((dropdown) => {
                    const culture = e.target.getAttribute("data-culture");
                    window.location.href = window.location.href.replace(
                        "/" + CULTURE_EMPREGARE,
                        "/" + culture
                    );
                }))
    );
};

